import Icon from "hardcover-ui/components/Icon";
import faChevronDown from "icons/solid/chevron-down.svg";
import Button from "hardcover-ui/components/Button";
import LoadingSpinner from "hardcover-ui/components/LoadingSpinner";
import { LetterbookSettingType } from "features/Letterbooks/types";
import Avatar from "hardcover-ui/components/Avatar";
import { findIcon } from "./SortListButton";

export default function InactiveSortBooksButton({
  loading = false,
  onClick = () => {},
  settings,
}: {
  loading?: boolean;
  onClick?: any;
  settings: LetterbookSettingType;
}) {
  const { order } = settings;

  return (
    <Button variant="pill" size="sm" onClick={onClick}>
      <Icon size="lg" icon={findIcon(order.type, order.direction === "desc")} />
      <span className="hidden lg:inline">Sort:</span>
      <span className="font-semibold flex items-center whitespace-nowrap">
        {order.user ? (
          <Avatar
            alt={order.user.username}
            image={order.user.image}
            size="xs"
            className="mr-2"
          />
        ) : (
          false
        )}
        {order.title}
      </span>
      {loading ? <LoadingSpinner size="sm" /> : <Icon icon={faChevronDown} />}
    </Button>
  );
}
